{
  "schemaVersion": 1,
  "locale": "en",
  "entries": {
    "domain:1": {
      "kind": "domain",
      "id": 1,
      "parentKey": null,
      "slug": "life-sciences",
      "name": "Life Sciences",
      "description": "The study of living organisms and life processes, encompassing biology, ecology, genetics, molecular biology, agriculture, zoology, botany, and the fundamental mechanisms that govern life from the molecular to the ecosystem level"
    },
    "domain:2": {
      "kind": "domain",
      "id": 2,
      "parentKey": null,
      "slug": "social-sciences",
      "name": "Social Sciences",
      "description": "The systematic study of human society and social relationships, including economics, psychology, sociology, political science, anthropology, education, law, linguistics, and the humanities, examining how people interact with one another and shape civilizations"
    },
    "domain:3": {
      "kind": "domain",
      "id": 3,
      "parentKey": null,
      "slug": "physical-sciences",
      "name": "Physical Sciences",
      "description": "The study of non-living matter and energy, encompassing physics, chemistry, astronomy, earth sciences, mathematics, computer science, engineering, and materials science, exploring the fundamental laws and principles that govern the natural world"
    },
    "domain:4": {
      "kind": "domain",
      "id": 4,
      "parentKey": null,
      "slug": "health-sciences",
      "name": "Health Sciences",
      "description": "The applied sciences dedicated to improving human and animal health through medicine, nursing, dentistry, pharmacy, public health, clinical research, and healthcare delivery systems, focusing on disease prevention, diagnosis, treatment, and wellness"
    },
    "field:11": {
      "kind": "field",
      "id": 11,
      "parentKey": "domain:1",
      "slug": "agricultural-and-biological-sciences",
      "name": "Agricultural and Biological Sciences",
      "description": "The study of living organisms and their interactions with the environment, including agriculture, ecology, plant biology, animal biology, conservation, forestry, marine biology, and sustainable food production systems"
    },
    "field:12": {
      "kind": "field",
      "id": 12,
      "parentKey": "domain:2",
      "slug": "arts-and-humanities",
      "name": "Arts and Humanities",
      "description": "The study of human culture and creative expression, including literature, philosophy, history, linguistics, music, visual arts, performing arts, cultural studies, and the exploration of human values, ideas, and artistic achievements"
    },
    "field:13": {
      "kind": "field",
      "id": 13,
      "parentKey": "domain:1",
      "slug": "biochemistry-genetics-and-molecular-biology",
      "name": "Biochemistry, Genetics and Molecular Biology",
      "description": "The molecular basis of life, exploring the chemical processes within living organisms, genetic inheritance, DNA/RNA structure and function, protein synthesis, cell biology, and the molecular mechanisms underlying biological phenomena"
    },
    "field:14": {
      "kind": "field",
      "id": 14,
      "parentKey": "domain:2",
      "slug": "business-management-and-accounting",
      "name": "Business, Management and Accounting",
      "description": "The study of organizational operations, strategy, and financial management, including entrepreneurship, marketing, human resources, operations management, leadership, corporate finance, accounting principles, and business analytics"
    },
    "field:15": {
      "kind": "field",
      "id": 15,
      "parentKey": "domain:3",
      "slug": "chemical-engineering",
      "name": "Chemical Engineering",
      "description": "The application of chemistry, physics, and mathematics to industrial processes, including reactor design, process optimization, materials synthesis, separation technologies, biotechnology applications, and sustainable manufacturing systems"
    },
    "field:16": {
      "kind": "field",
      "id": 16,
      "parentKey": "domain:3",
      "slug": "chemistry",
      "name": "Chemistry",
      "description": "The study of matter and its properties, reactions, and transformations, including organic, inorganic, physical, and analytical chemistry, as well as the development of new materials, drugs, and understanding of molecular interactions"
    },
    "field:17": {
      "kind": "field",
      "id": 17,
      "parentKey": "domain:3",
      "slug": "computer-science",
      "name": "Computer Science",
      "description": "The study of computation, information processing, and intelligent systems, including algorithms, artificial intelligence, machine learning, software engineering, cybersecurity, databases, networks, and human-computer interaction"
    },
    "field:18": {
      "kind": "field",
      "id": 18,
      "parentKey": "domain:2",
      "slug": "decision-sciences",
      "name": "Decision Sciences",
      "description": "The application of quantitative methods to improve decision-making, including operations research, management science, statistics, risk analysis, game theory, optimization, and data-driven approaches to complex business and societal problems"
    },
    "field:19": {
      "kind": "field",
      "id": 19,
      "parentKey": "domain:3",
      "slug": "earth-and-planetary-sciences",
      "name": "Earth and Planetary Sciences",
      "description": "The study of Earth and other celestial bodies, including geology, oceanography, atmospheric science, climatology, seismology, planetary formation, natural resources, and the physical processes shaping planets and their environments"
    },
    "field:20": {
      "kind": "field",
      "id": 20,
      "parentKey": "domain:2",
      "slug": "economics-econometrics-and-finance",
      "name": "Economics, Econometrics and Finance",
      "description": "The study of resource allocation, market behavior, and financial systems, including microeconomics, macroeconomics, international trade, monetary policy, financial markets, investment analysis, and quantitative economic modeling"
    },
    "field:21": {
      "kind": "field",
      "id": 21,
      "parentKey": "domain:3",
      "slug": "energy",
      "name": "Energy",
      "description": "The interdisciplinary study of energy systems and technologies, including renewable energy, fossil fuels, nuclear power, energy storage, efficiency, sustainability, climate change mitigation, and the transition to clean energy economies"
    },
    "field:22": {
      "kind": "field",
      "id": 22,
      "parentKey": "domain:3",
      "slug": "engineering",
      "name": "Engineering",
      "description": "The application of scientific principles to design and build systems, including mechanical, electrical, civil, aerospace, biomedical, and industrial engineering, focusing on solving practical problems and advancing technological innovation"
    },
    "field:23": {
      "kind": "field",
      "id": 23,
      "parentKey": "domain:3",
      "slug": "environmental-science",
      "name": "Environmental Science",
      "description": "The integrated study of physical, chemical, and biological processes in the environment, including ecology, conservation, pollution, climate change, sustainability, environmental policy, and the impact of human activities on natural systems"
    },
    "field:24": {
      "kind": "field",
      "id": 24,
      "parentKey": "domain:1",
      "slug": "immunology-and-microbiology",
      "name": "Immunology and Microbiology",
      "description": "The study of microorganisms and the immune system, including bacteria, viruses, fungi, parasites, infectious diseases, immune responses, vaccines, antibiotics, and the complex interactions between pathogens and host defense mechanisms"
    },
    "field:25": {
      "kind": "field",
      "id": 25,
      "parentKey": "domain:3",
      "slug": "materials-science",
      "name": "Materials Science",
      "description": "The study of the properties and applications of materials, including metals, ceramics, polymers, composites, nanomaterials, semiconductors, and biomaterials, focusing on structure-property relationships and novel material development"
    },
    "field:26": {
      "kind": "field",
      "id": 26,
      "parentKey": "domain:3",
      "slug": "mathematics",
      "name": "Mathematics",
      "description": "The study of abstract structures, patterns, and relationships, including pure mathematics (algebra, analysis, geometry, topology), applied mathematics, statistics, computational mathematics, and the mathematical foundations underlying all sciences"
    },
    "field:27": {
      "kind": "field",
      "id": 27,
      "parentKey": "domain:4",
      "slug": "medicine",
      "name": "Medicine",
      "description": "The science and practice of diagnosing, treating, and preventing disease, including clinical medicine, surgery, internal medicine, pediatrics, psychiatry, medical research, and the advancement of therapeutic interventions for human health"
    },
    "field:28": {
      "kind": "field",
      "id": 28,
      "parentKey": "domain:1",
      "slug": "neuroscience",
      "name": "Neuroscience",
      "description": "The scientific study of the nervous system, including brain function, neural development, cognitive processes, behavior, neurological disorders, consciousness, memory, learning, and the biological basis of mental phenomena"
    },
    "field:29": {
      "kind": "field",
      "id": 29,
      "parentKey": "domain:4",
      "slug": "nursing",
      "name": "Nursing",
      "description": "The art and science of caring for individuals across the lifespan, including clinical nursing practice, patient advocacy, health promotion, disease prevention, nursing education, and the delivery of compassionate healthcare in diverse settings"
    },
    "field:30": {
      "kind": "field",
      "id": 30,
      "parentKey": "domain:1",
      "slug": "pharmacology-toxicology-and-pharmaceutics",
      "name": "Pharmacology, Toxicology and Pharmaceutics",
      "description": "The study of drugs and their effects on living systems, including drug discovery, development, and delivery, pharmacokinetics, toxicology, pharmaceutical chemistry, clinical pharmacy, and the safe and effective use of medications"
    },
    "field:31": {
      "kind": "field",
      "id": 31,
      "parentKey": "domain:3",
      "slug": "physics-and-astronomy",
      "name": "Physics and Astronomy",
      "description": "The fundamental study of matter, energy, and the universe, including quantum mechanics, relativity, particle physics, astrophysics, cosmology, condensed matter physics, and the exploration of natural laws governing physical phenomena"
    },
    "field:32": {
      "kind": "field",
      "id": 32,
      "parentKey": "domain:2",
      "slug": "psychology",
      "name": "Psychology",
      "description": "The scientific study of mind and behavior, including cognitive processes, emotional development, social interactions, mental health, personality, human development, clinical psychology, and the biological bases of psychological phenomena"
    },
    "field:33": {
      "kind": "field",
      "id": 33,
      "parentKey": "domain:2",
      "slug": "social-sciences",
      "name": "Social Sciences",
      "description": "The study of human society and social relationships, including sociology, anthropology, political science, geography, communication studies, international relations, urban planning, and the systematic analysis of social structures and cultural practices"
    },
    "field:34": {
      "kind": "field",
      "id": 34,
      "parentKey": "domain:4",
      "slug": "veterinary",
      "name": "Veterinary",
      "description": "The medical care and treatment of animals, including companion animals, livestock, wildlife, and exotic species, encompassing veterinary medicine, surgery, preventive care, public health, and the critical role of animal health in human wellbeing"
    },
    "field:35": {
      "kind": "field",
      "id": 35,
      "parentKey": "domain:4",
      "slug": "dentistry",
      "name": "Dentistry",
      "description": "The branch of medicine focused on oral health, including the diagnosis, prevention, and treatment of diseases affecting teeth, gums, and oral structures, as well as oral surgery, orthodontics, and the relationship between oral and systemic health"
    },
    "field:36": {
      "kind": "field",
      "id": 36,
      "parentKey": "domain:4",
      "slug": "health-professions",
      "name": "Health Professions",
      "description": "The allied health disciplines supporting healthcare delivery, including physical therapy, occupational therapy, public health, health administration, nutrition, medical technology, and other specialized healthcare services"
    },
    "subfield:1100": {
      "kind": "subfield",
      "id": 1100,
      "parentKey": "field:11",
      "slug": "general-agricultural-and-biological-sciences",
      "name": "General Agricultural and Biological Sciences",
      "description": "Broad interdisciplinary research spanning multiple areas of agriculture and biology, including integrated approaches to food security, biotechnology applications, environmental sustainability, and the interface between agricultural systems and natural ecosystems"
    },
    "subfield:1102": {
      "kind": "subfield",
      "id": 1102,
      "parentKey": "field:11",
      "slug": "agronomy-and-crop-science",
      "name": "Agronomy and Crop Science",
      "description": "The science of soil management and crop production, including plant breeding, crop physiology, soil fertility, irrigation systems, pest management, and sustainable farming practices to optimize agricultural yield and quality"
    },
    "subfield:1103": {
      "kind": "subfield",
      "id": 1103,
      "parentKey": "field:11",
      "slug": "animal-science-and-zoology",
      "name": "Animal Science and Zoology",
      "description": "The comprehensive study of animal biology, behavior, physiology, and ecology, including livestock production, animal nutrition, breeding, welfare, wildlife conservation, and the evolutionary relationships among animal species"
    },
    "subfield:1104": {
      "kind": "subfield",
      "id": 1104,
      "parentKey": "field:11",
      "slug": "aquatic-science",
      "name": "Aquatic Science",
      "description": "The interdisciplinary study of freshwater and marine ecosystems, including limnology, oceanography, aquatic ecology, fisheries science, water quality, and the conservation of aquatic biodiversity and resources"
    },
    "subfield:1105": {
      "kind": "subfield",
      "id": 1105,
      "parentKey": "field:11",
      "slug": "ecology-evolution-behavior-and-systematics",
      "name": "Ecology, Evolution, Behavior and Systematics",
      "description": "The integrated study of how organisms interact with their environment, evolve over time, exhibit behaviors, and are classified, including population dynamics, community ecology, evolutionary biology, behavioral ecology, and taxonomic relationships"
    },
    "subfield:1106": {
      "kind": "subfield",
      "id": 1106,
      "parentKey": "field:11",
      "slug": "food-science",
      "name": "Food Science",
      "description": "The application of biological, chemical, and physical sciences to study food properties, processing, preservation, safety, and nutrition, including food chemistry, microbiology, engineering, sensory analysis, and product development"
    },
    "subfield:1107": {
      "kind": "subfield",
      "id": 1107,
      "parentKey": "field:11",
      "slug": "forestry",
      "name": "Forestry",
      "description": "The science and practice of managing forest ecosystems for timber production, conservation, recreation, and ecosystem services, including silviculture, forest ecology, fire management, and sustainable forest resource utilization"
    },
    "subfield:1108": {
      "kind": "subfield",
      "id": 1108,
      "parentKey": "field:11",
      "slug": "horticulture",
      "name": "Horticulture",
      "description": "The science and art of cultivating fruits, vegetables, flowers, and ornamental plants, including plant propagation, greenhouse management, landscape design, post-harvest technology, and urban agriculture"
    },
    "subfield:1109": {
      "kind": "subfield",
      "id": 1109,
      "parentKey": "field:11",
      "slug": "insect-science",
      "name": "Insect Science",
      "description": "The study of insects and their interactions with humans, plants, and ecosystems, including entomology, pest management, pollinator biology, insect physiology, behavior, systematics, and their roles in agriculture and disease transmission"
    },
    "subfield:1110": {
      "kind": "subfield",
      "id": 1110,
      "parentKey": "field:11",
      "slug": "plant-science",
      "name": "Plant Science",
      "description": "The comprehensive study of plant biology, including plant physiology, molecular biology, genetics, pathology, biotechnology, and the development of improved crop varieties for food, fiber, and environmental applications"
    },
    "subfield:1111": {
      "kind": "subfield",
      "id": 1111,
      "parentKey": "field:11",
      "slug": "soil-science",
      "name": "Soil Science",
      "description": "The study of soil as a natural resource, including soil formation, classification, mapping, fertility, chemistry, biology, physics, and management for agricultural production and environmental protection"
    },
    "subfield:1200": {
      "kind": "subfield",
      "id": 1200,
      "parentKey": "field:12",
      "slug": "general-arts-and-humanities",
      "name": "General Arts and Humanities",
      "description": "Interdisciplinary scholarship that bridges multiple humanities disciplines, exploring human culture, creativity, and expression through integrated approaches to art, literature, history, philosophy, and cultural studies"
    },
    "subfield:1202": {
      "kind": "subfield",
      "id": 1202,
      "parentKey": "field:12",
      "slug": "history",
      "name": "History",
      "description": "The systematic study and interpretation of past events, societies, and cultures through primary sources, archives, and historiographical methods, examining political, social, economic, and cultural developments across time and geography"
    },
    "subfield:1203": {
      "kind": "subfield",
      "id": 1203,
      "parentKey": "field:12",
      "slug": "language-and-linguistics",
      "name": "Language and Linguistics",
      "description": "The scientific study of human language structure, acquisition, use, and evolution, including phonetics, syntax, semantics, pragmatics, sociolinguistics, and the documentation of endangered languages"
    },
    "subfield:1204": {
      "kind": "subfield",
      "id": 1204,
      "parentKey": "field:12",
      "slug": "archeology",
      "name": "Archeology",
      "description": "The scientific study of human history and prehistory through the excavation and analysis of artifacts, structures, and cultural remains, including field methods, dating techniques, and interpretations of past societies"
    },
    "subfield:1205": {
      "kind": "subfield",
      "id": 1205,
      "parentKey": "field:12",
      "slug": "classics",
      "name": "Classics",
      "description": "The study of ancient Greek and Roman civilizations, including their languages, literature, history, philosophy, art, and cultural legacy, examining texts, archaeological evidence, and their influence on modern society"
    },
    "subfield:1206": {
      "kind": "subfield",
      "id": 1206,
      "parentKey": "field:12",
      "slug": "conservation",
      "name": "Conservation",
      "description": "The preservation and restoration of cultural heritage, including artworks, historical documents, archaeological artifacts, and architectural monuments, using scientific analysis, ethical practices, and preventive care strategies"
    },
    "subfield:1207": {
      "kind": "subfield",
      "id": 1207,
      "parentKey": "field:12",
      "slug": "history-and-philosophy-of-science",
      "name": "History and Philosophy of Science",
      "description": "The examination of scientific development, methodology, and epistemology across history, analyzing how scientific knowledge is constructed, validated, and changes over time, including the social and cultural contexts of scientific practice"
    },
    "subfield:1208": {
      "kind": "subfield",
      "id": 1208,
      "parentKey": "field:12",
      "slug": "literature-and-literary-theory",
      "name": "Literature and Literary Theory",
      "description": "The analysis and interpretation of written texts across cultures and periods, including critical theory, comparative literature, genre studies, narrative analysis, and the exploration of literature's role in society and human experience"
    },
    "subfield:1209": {
      "kind": "subfield",
      "id": 1209,
      "parentKey": "field:12",
      "slug": "museology",
      "name": "Museology",
      "description": "The theory and practice of museum operations, including collection management, exhibition design, educational programming, digital curation, audience engagement, and the role of museums in preserving and interpreting cultural heritage"
    },
    "subfield:1210": {
      "kind": "subfield",
      "id": 1210,
      "parentKey": "field:12",
      "slug": "music",
      "name": "Music",
      "description": "The academic study of music in all its forms, including music theory, composition, performance, ethnomusicology, music history, acoustics, and the cultural, social, and cognitive aspects of musical expression"
    },
    "subfield:1211": {
      "kind": "subfield",
      "id": 1211,
      "parentKey": "field:12",
      "slug": "philosophy",
      "name": "Philosophy",
      "description": "The systematic investigation of fundamental questions about existence, knowledge, values, reason, mind, and language, including metaphysics, epistemology, ethics, logic, aesthetics, and political philosophy"
    },
    "subfield:1212": {
      "kind": "subfield",
      "id": 1212,
      "parentKey": "field:12",
      "slug": "religious-studies",
      "name": "Religious studies",
      "description": "The academic examination of religious beliefs, practices, institutions, and experiences across cultures, including comparative religion, theology, sacred texts, ritual studies, and the role of religion in contemporary society"
    },
    "subfield:1213": {
      "kind": "subfield",
      "id": 1213,
      "parentKey": "field:12",
      "slug": "visual-arts-and-performing-arts",
      "name": "Visual Arts and Performing Arts",
      "description": "The study and practice of artistic expression through visual media and performance, including painting, sculpture, photography, theater, dance, film, and digital arts, examining both creative processes and critical analysis"
    },
    "subfield:1300": {
      "kind": "subfield",
      "id": 1300,
      "parentKey": "field:13",
      "slug": "general-biochemistry-genetics-and-molecular-biology",
      "name": "General Biochemistry, Genetics and Molecular Biology",
      "description": "Interdisciplinary research spanning multiple areas of biochemistry, genetics and molecular biology that bridges traditional boundaries within this field"
    },
    "subfield:1302": {
      "kind": "subfield",
      "id": 1302,
      "parentKey": "field:13",
      "slug": "aging",
      "name": "Aging",
      "description": "The biological study of aging processes at molecular, cellular, and organismal levels, including mechanisms of senescence, age-related diseases, longevity, regenerative medicine, and interventions to promote healthy aging"
    },
    "subfield:1303": {
      "kind": "subfield",
      "id": 1303,
      "parentKey": "field:13",
      "slug": "biochemistry",
      "name": "Biochemistry",
      "description": "The chemical processes and substances within living organisms, studying proteins, nucleic acids, carbohydrates, lipids, and their interactions, including enzyme function, metabolic pathways, and molecular mechanisms of life"
    },
    "subfield:1304": {
      "kind": "subfield",
      "id": 1304,
      "parentKey": "field:13",
      "slug": "biophysics",
      "name": "Biophysics",
      "description": "The application of physical principles and methods to understand biological systems, including biomolecular structure and dynamics, membrane biophysics, cellular mechanics, and the development of biophysical techniques"
    },
    "subfield:1305": {
      "kind": "subfield",
      "id": 1305,
      "parentKey": "field:13",
      "slug": "biotechnology",
      "name": "Biotechnology",
      "description": "The application of biological systems and organisms to develop products and technologies, including genetic engineering, synthetic biology, biopharmaceuticals, industrial biotechnology, and agricultural biotechnology applications"
    },
    "subfield:1306": {
      "kind": "subfield",
      "id": 1306,
      "parentKey": "field:13",
      "slug": "cancer-research",
      "name": "Cancer Research",
      "description": "The multidisciplinary study of cancer biology, including carcinogenesis, tumor progression, metastasis, cancer genetics, immunology, and the development of diagnostic, preventive, and therapeutic strategies"
    },
    "subfield:1307": {
      "kind": "subfield",
      "id": 1307,
      "parentKey": "field:13",
      "slug": "cell-biology",
      "name": "Cell Biology",
      "description": "The study of cell structure, function, and behavior, including organelles, cell division, signaling, metabolism, differentiation, and the molecular mechanisms governing cellular processes in health and disease"
    },
    "subfield:1308": {
      "kind": "subfield",
      "id": 1308,
      "parentKey": "field:13",
      "slug": "clinical-biochemistry",
      "name": "Clinical Biochemistry",
      "description": "The analysis of body fluids and tissues for diagnostic and therapeutic monitoring, including development of biomarkers, clinical assays, point-of-care testing, and the biochemical basis of disease"
    },
    "subfield:1309": {
      "kind": "subfield",
      "id": 1309,
      "parentKey": "field:13",
      "slug": "developmental-biology",
      "name": "Developmental Biology",
      "description": "The study of how organisms grow and develop from fertilization to maturity, including embryogenesis, morphogenesis, cell differentiation, pattern formation, stem cell biology, and regeneration"
    },
    "subfield:1310": {
      "kind": "subfield",
      "id": 1310,
      "parentKey": "field:13",
      "slug": "endocrinology",
      "name": "Endocrinology",
      "description": "The study of hormones and the endocrine system, including hormone synthesis, secretion, and action, endocrine disorders, neuroendocrinology, and the regulation of metabolism, growth, and reproduction"
    },
    "subfield:1311": {
      "kind": "subfield",
      "id": 1311,
      "parentKey": "field:13",
      "slug": "genetics",
      "name": "Genetics",
      "description": "The study of heredity and genetic variation, including molecular genetics, population genetics, genomics, epigenetics, genetic engineering, and the genetic basis of traits, evolution, and disease"
    },
    "subfield:1312": {
      "kind": "subfield",
      "id": 1312,
      "parentKey": "field:13",
      "slug": "molecular-biology",
      "name": "Molecular Biology",
      "description": "The molecular mechanisms of biological processes, focusing on DNA, RNA, and protein interactions, gene expression, signal transduction, molecular techniques, and the molecular basis of cellular function"
    },
    "subfield:1313": {
      "kind": "subfield",
      "id": 1313,
      "parentKey": "field:13",
      "slug": "molecular-medicine",
      "name": "Molecular Medicine",
      "description": "The application of molecular biology to understand and treat disease, including molecular diagnostics, personalized medicine, gene therapy, drug development, and translational research from bench to bedside"
    },
    "subfield:1314": {
      "kind": "subfield",
      "id": 1314,
      "parentKey": "field:13",
      "slug": "physiology",
      "name": "Physiology",
      "description": "The study of how organisms function at all levels, from molecules to organ systems, including cardiovascular, respiratory, neural, renal, and digestive physiology, homeostasis, and adaptation to environmental challenges"
    },
    "subfield:1315": {
      "kind": "subfield",
      "id": 1315,
      "parentKey": "field:13",
      "slug": "structural-biology",
      "name": "Structural Biology",
      "description": "The determination and analysis of three-dimensional structures of biological macromolecules, using techniques like crystallography, NMR, and cryo-EM to understand structure-function relationships and drug design"
    },
    "subfield:1400": {
      "kind": "subfield",
      "id": 1400,
      "parentKey": "field:14",
      "slug": "general-business-management-and-accounting",
      "name": "General Business, Management and Accounting",
      "description": "Interdisciplinary research spanning multiple areas of business, management and accounting that bridges traditional boundaries within this field"
    },
    "subfield:1402": {
      "kind": "subfield",
      "id": 1402,
      "parentKey": "field:14",
      "slug": "accounting",
      "name": "Accounting",
      "description": "The measurement, processing, and communication of financial information, including financial accounting, managerial accounting, auditing, taxation, forensic accounting, and accounting information systems"
    },
    "subfield:1403": {
      "kind": "subfield",
      "id": 1403,
      "parentKey": "field:14",
      "slug": "business-and-international-management",
      "name": "Business and International Management",
      "description": "The study of global business operations and cross-cultural management, including international strategy, global supply chains, foreign market entry, multinational corporations, and managing diversity in international contexts"
    },
    "subfield:1404": {
      "kind": "subfield",
      "id": 1404,
      "parentKey": "field:14",
      "slug": "management-information-systems",
      "name": "Management Information Systems",
      "description": "The design, implementation, and management of information technology in organizations, including enterprise systems, business intelligence, IT strategy, cybersecurity management, and digital transformation"
    },
    "subfield:1405": {
      "kind": "subfield",
      "id": 1405,
      "parentKey": "field:14",
      "slug": "management-of-technology-and-innovation",
      "name": "Management of Technology and Innovation",
      "description": "The strategic management of technological change and innovation processes, including R&D management, technology transfer, innovation ecosystems, intellectual property, and commercialization of new technologies"
    },
    "subfield:1406": {
      "kind": "subfield",
      "id": 1406,
      "parentKey": "field:14",
      "slug": "marketing",
      "name": "Marketing",
      "description": "The study of market dynamics and consumer behavior to create, communicate, and deliver value, including market research, branding, digital marketing, consumer psychology, pricing strategies, and marketing analytics"
    },
    "subfield:1407": {
      "kind": "subfield",
      "id": 1407,
      "parentKey": "field:14",
      "slug": "organizational-behavior-and-human-resource-management",
      "name": "Organizational Behavior and Human Resource Management",
      "description": "The study of human behavior in organizational settings and management of human capital, including leadership, motivation, team dynamics, organizational culture, talent management, and employee development"
    },
    "subfield:1408": {
      "kind": "subfield",
      "id": 1408,
      "parentKey": "field:14",
      "slug": "strategy-and-management",
      "name": "Strategy and Management",
      "description": "The formulation and implementation of organizational strategies for competitive advantage, including strategic planning, corporate governance, organizational design, change management, and performance measurement"
    },
    "subfield:1409": {
      "kind": "subfield",
      "id": 1409,
      "parentKey": "field:14",
      "slug": "tourism-leisure-and-hospitality-management",
      "name": "Tourism, Leisure and Hospitality Management",
      "description": "The management of tourism destinations, hospitality services, and leisure activities, including sustainable tourism, destination marketing, hotel and restaurant management, event planning, and tourist behavior"
    },
    "subfield:1410": {
      "kind": "subfield",
      "id": 1410,
      "parentKey": "field:14",
      "slug": "industrial-relations",
      "name": "Industrial relations",
      "description": "The study of employment relationships between workers, employers, and governments, including labor unions, collective bargaining, workplace conflict resolution, employment law, and human resource policies"
    },
    "subfield:1500": {
      "kind": "subfield",
      "id": 1500,
      "parentKey": "field:15",
      "slug": "general-chemical-engineering",
      "name": "General Chemical Engineering",
      "description": "Interdisciplinary research spanning multiple areas of chemical engineering that bridges traditional boundaries within this field"
    },
    "subfield:1502": {
      "kind": "subfield",
      "id": 1502,
      "parentKey": "field:15",
      "slug": "bioengineering",
      "name": "Bioengineering",
      "description": "The application of engineering principles to biological systems, including bioprocess engineering, metabolic engineering, bioreactor design, fermentation technology, and the production of biopharmaceuticals and biomaterials"
    },
    "subfield:1503": {
      "kind": "subfield",
      "id": 1503,
      "parentKey": "field:15",
      "slug": "catalysis",
      "name": "Catalysis",
      "description": "The science of accelerating chemical reactions using catalysts, including heterogeneous and homogeneous catalysis, enzyme catalysis, catalyst design, reaction mechanisms, and industrial catalytic processes"
    },
    "subfield:1504": {
      "kind": "subfield",
      "id": 1504,
      "parentKey": "field:15",
      "slug": "chemical-health-and-safety",
      "name": "Chemical Health and Safety",
      "description": "The safe handling, storage, and disposal of chemicals in industrial and laboratory settings, including hazard assessment, exposure control, emergency response, regulatory compliance, and process safety management"
    },
    "subfield:1506": {
      "kind": "subfield",
      "id": 1506,
      "parentKey": "field:15",
      "slug": "filtration-and-separation",
      "name": "Filtration and Separation",
      "description": "The design and optimization of separation processes, including membrane technology, chromatography, distillation, extraction, crystallization, and the development of novel separation materials and methods"
    },
    "subfield:1507": {
      "kind": "subfield",
      "id": 1507,
      "parentKey": "field:15",
      "slug": "fluid-flow-and-transfer-processes",
      "name": "Fluid Flow and Transfer Processes",
      "description": "The study of fluid dynamics, heat and mass transfer in chemical processes, including reactor design, mixing, multiphase flow, computational fluid dynamics, and transport phenomena in industrial applications"
    },
    "subfield:1508": {
      "kind": "subfield",
      "id": 1508,
      "parentKey": "field:15",
      "slug": "process-chemistry-and-technology",
      "name": "Process Chemistry and Technology",
      "description": "The development and optimization of chemical manufacturing processes, including process intensification, green chemistry, scale-up, continuous processing, and integration of unit operations for efficient production"
    },
    "subfield:1600": {
      "kind": "subfield",
      "id": 1600,
      "parentKey": "field:16",
      "slug": "general-chemistry",
      "name": "General Chemistry",
      "description": "Interdisciplinary research spanning multiple areas of chemistry that bridges traditional boundaries within this field"
    },
    "subfield:1602": {
      "kind": "subfield",
      "id": 1602,
      "parentKey": "field:16",
      "slug": "analytical-chemistry",
      "name": "Analytical Chemistry",
      "description": "The development and application of methods to identify and quantify matter, including spectroscopy, chromatography, mass spectrometry, electroanalytical techniques, and chemical sensors for various applications"
    },
    "subfield:1603": {
      "kind": "subfield",
      "id": 1603,
      "parentKey": "field:16",
      "slug": "electrochemistry",
      "name": "Electrochemistry",
      "description": "The study of chemical processes involving electron transfer, including batteries, fuel cells, corrosion, electroplating, electroanalysis, and the development of electrochemical sensors and energy storage devices"
    },
    "subfield:1604": {
      "kind": "subfield",
      "id": 1604,
      "parentKey": "field:16",
      "slug": "inorganic-chemistry",
      "name": "Inorganic Chemistry",
      "description": "The study of inorganic compounds and materials, including coordination chemistry, organometallic chemistry, solid-state chemistry, bioinorganic chemistry, and the synthesis of advanced inorganic materials"
    },
    "subfield:1605": {
      "kind": "subfield",
      "id": 1605,
      "parentKey": "field:16",
      "slug": "organic-chemistry",
      "name": "Organic Chemistry",
      "description": "The study of carbon-containing compounds, including synthesis, reaction mechanisms, stereochemistry, natural products, medicinal chemistry, and the development of new synthetic methodologies"
    },
    "subfield:1606": {
      "kind": "subfield",
      "id": 1606,
      "parentKey": "field:16",
      "slug": "physical-and-theoretical-chemistry",
      "name": "Physical and Theoretical Chemistry",
      "description": "The study of chemical phenomena using physics and mathematical models, including thermodynamics, kinetics, quantum chemistry, statistical mechanics, and computational chemistry methods"
    },
    "subfield:1607": {
      "kind": "subfield",
      "id": 1607,
      "parentKey": "field:16",
      "slug": "spectroscopy",
      "name": "Spectroscopy",
      "description": "The study of matter's interaction with electromagnetic radiation, including NMR, IR, UV-Vis, Raman spectroscopy, and advanced spectroscopic techniques for structural analysis and chemical identification"
    },
    "subfield:1700": {
      "kind": "subfield",
      "id": 1700,
      "parentKey": "field:17",
      "slug": "general-computer-science",
      "name": "General Computer Science",
      "description": "Interdisciplinary research spanning multiple areas of computer science that bridges traditional boundaries within this field"
    },
    "subfield:1702": {
      "kind": "subfield",
      "id": 1702,
      "parentKey": "field:17",
      "slug": "artificial-intelligence",
      "name": "Artificial Intelligence",
      "description": "The development of intelligent systems that can perceive, reason, learn, and act, including machine learning, deep learning, natural language processing, robotics, expert systems, and AI ethics"
    },
    "subfield:1703": {
      "kind": "subfield",
      "id": 1703,
      "parentKey": "field:17",
      "slug": "computational-theory-and-mathematics",
      "name": "Computational Theory and Mathematics",
      "description": "The mathematical foundations of computing, including algorithms, complexity theory, automata theory, formal languages, cryptography, and the theoretical limits of computation"
    },
    "subfield:1704": {
      "kind": "subfield",
      "id": 1704,
      "parentKey": "field:17",
      "slug": "computer-graphics-and-computer-aided-design",
      "name": "Computer Graphics and Computer-Aided Design",
      "description": "The creation and manipulation of visual content using computers, including 3D modeling, rendering, animation, visualization, virtual reality, CAD/CAM systems, and computational geometry"
    },
    "subfield:1705": {
      "kind": "subfield",
      "id": 1705,
      "parentKey": "field:17",
      "slug": "computer-networks-and-communications",
      "name": "Computer Networks and Communications",
      "description": "The design and analysis of communication systems and networks, including protocols, wireless networks, Internet architecture, network security, distributed systems, and emerging networking technologies"
    },
    "subfield:1706": {
      "kind": "subfield",
      "id": 1706,
      "parentKey": "field:17",
      "slug": "computer-science-applications",
      "name": "Computer Science Applications",
      "description": "The practical application of computing to solve real-world problems, including bioinformatics, computational science, digital humanities, e-commerce, social computing, and domain-specific software solutions"
    },
    "subfield:1707": {
      "kind": "subfield",
      "id": 1707,
      "parentKey": "field:17",
      "slug": "computer-vision-and-pattern-recognition",
      "name": "Computer Vision and Pattern Recognition",
      "description": "The automatic extraction and interpretation of information from images and video, including object detection, facial recognition, medical imaging analysis, autonomous vehicles, and visual understanding systems"
    },
    "subfield:1708": {
      "kind": "subfield",
      "id": 1708,
      "parentKey": "field:17",
      "slug": "hardware-and-architecture",
      "name": "Hardware and Architecture",
      "description": "The design and organization of computer systems, including processor architecture, memory systems, parallel computing, embedded systems, quantum computing hardware, and energy-efficient computing"
    },
    "subfield:1709": {
      "kind": "subfield",
      "id": 1709,
      "parentKey": "field:17",
      "slug": "human-computer-interaction",
      "name": "Human-Computer Interaction",
      "description": "The design and evaluation of user interfaces and interactive systems, including usability, user experience, accessibility, mobile computing, augmented reality, and social aspects of computing"
    },
    "subfield:1710": {
      "kind": "subfield",
      "id": 1710,
      "parentKey": "field:17",
      "slug": "information-systems",
      "name": "Information Systems",
      "description": "The study of how organizations use information technology, including database systems, information retrieval, knowledge management, enterprise systems, and the socio-technical aspects of IT deployment"
    },
    "subfield:1711": {
      "kind": "subfield",
      "id": 1711,
      "parentKey": "field:17",
      "slug": "signal-processing",
      "name": "Signal Processing",
      "description": "The analysis and manipulation of signals, including digital signal processing, image processing, audio processing, compression, filtering, and applications in communications and multimedia"
    },
    "subfield:1712": {
      "kind": "subfield",
      "id": 1712,
      "parentKey": "field:17",
      "slug": "software",
      "name": "Software",
      "description": "The engineering of software systems, including programming languages, software architecture, testing, verification, agile methods, DevOps, and the management of large-scale software projects"
    },
    "subfield:1800": {
      "kind": "subfield",
      "id": 1800,
      "parentKey": "field:18",
      "slug": "general-decision-sciences",
      "name": "General Decision Sciences",
      "description": "Interdisciplinary approaches to decision-making that combine multiple methodologies, including behavioral decision theory, multi-criteria analysis, and integrated frameworks for complex decision problems"
    },
    "subfield:1802": {
      "kind": "subfield",
      "id": 1802,
      "parentKey": "field:18",
      "slug": "information-systems-and-management",
      "name": "Information Systems and Management",
      "description": "The strategic use of information systems for decision support, including business intelligence, data analytics, knowledge management systems, and IT governance for organizational decision-making"
    },
    "subfield:1803": {
      "kind": "subfield",
      "id": 1803,
      "parentKey": "field:18",
      "slug": "management-science-and-operations-research",
      "name": "Management Science and Operations Research",
      "description": "Mathematical and analytical methods for optimal decision-making, including linear programming, simulation, queuing theory, supply chain optimization, and quantitative models for business operations"
    },
    "subfield:1804": {
      "kind": "subfield",
      "id": 1804,
      "parentKey": "field:18",
      "slug": "statistics-probability-and-uncertainty",
      "name": "Statistics, Probability and Uncertainty",
      "description": "Mathematical frameworks for analyzing data and uncertainty, including statistical inference, Bayesian methods, risk analysis, stochastic processes, and decision-making under uncertainty"
    },
    "subfield:1900": {
      "kind": "subfield",
      "id": 1900,
      "parentKey": "field:19",
      "slug": "general-earth-and-planetary-sciences",
      "name": "General Earth and Planetary Sciences",
      "description": "Interdisciplinary research spanning multiple areas of earth and planetary sciences that bridges traditional boundaries within this field"
    },
    "subfield:1902": {
      "kind": "subfield",
      "id": 1902,
      "parentKey": "field:19",
      "slug": "atmospheric-science",
      "name": "Atmospheric Science",
      "description": "The study of Earth's atmosphere and its processes, including meteorology, climatology, atmospheric chemistry, air quality, weather prediction, and the impacts of human activities on atmospheric composition"
    },
    "subfield:1904": {
      "kind": "subfield",
      "id": 1904,
      "parentKey": "field:19",
      "slug": "earth-surface-processes",
      "name": "Earth-Surface Processes",
      "description": "The study of processes shaping Earth's surface, including geomorphology, erosion, sedimentation, glaciology, hydrology, and the interactions between climate, tectonics, and landscape evolution"
    },
    "subfield:1906": {
      "kind": "subfield",
      "id": 1906,
      "parentKey": "field:19",
      "slug": "geochemistry-and-petrology",
      "name": "Geochemistry and Petrology",
      "description": "The chemical composition and formation of rocks and minerals, including igneous, metamorphic, and sedimentary processes, isotope geochemistry, and the cycling of elements through Earth systems"
    },
    "subfield:1907": {
      "kind": "subfield",
      "id": 1907,
      "parentKey": "field:19",
      "slug": "geology",
      "name": "Geology",
      "description": "The comprehensive study of Earth's structure, composition, and history, including mineralogy, stratigraphy, structural geology, economic geology, and the reconstruction of Earth's geological past"
    },
    "subfield:1908": {
      "kind": "subfield",
      "id": 1908,
      "parentKey": "field:19",
      "slug": "geophysics",
      "name": "Geophysics",
      "description": "The physics of Earth and its environment, including seismology, gravity, magnetism, electrical methods, and the use of geophysical techniques to explore Earth's interior and natural resources"
    },
    "subfield:1910": {
      "kind": "subfield",
      "id": 1910,
      "parentKey": "field:19",
      "slug": "oceanography",
      "name": "Oceanography",
      "description": "The multidisciplinary study of oceans, including physical oceanography, marine chemistry, biological oceanography, ocean circulation, marine ecosystems, and ocean-atmosphere interactions"
    },
    "subfield:1911": {
      "kind": "subfield",
      "id": 1911,
      "parentKey": "field:19",
      "slug": "paleontology",
      "name": "Paleontology",
      "description": "The study of ancient life through fossils, including evolution, extinction, paleoecology, biostratigraphy, and the reconstruction of past environments and biodiversity through geological time"
    },
    "subfield:1912": {
      "kind": "subfield",
      "id": 1912,
      "parentKey": "field:19",
      "slug": "space-and-planetary-science",
      "name": "Space and Planetary Science",
      "description": "The study of celestial bodies and space environments, including planetary geology, astrobiology, solar system formation, exoplanets, space weather, and missions to explore other worlds"
    },
    "subfield:2000": {
      "kind": "subfield",
      "id": 2000,
      "parentKey": "field:20",
      "slug": "general-economics-econometrics-and-finance",
      "name": "General Economics, Econometrics and Finance",
      "description": "Broad economic and financial research spanning multiple subfields, including interdisciplinary work on economic development, financial systems, monetary economics, and integrated economic-financial modeling"
    },
    "subfield:2002": {
      "kind": "subfield",
      "id": 2002,
      "parentKey": "field:20",
      "slug": "economics-and-econometrics",
      "name": "Economics and Econometrics",
      "description": "Economic theory and quantitative analysis of economic phenomena, including microeconomic and macroeconomic theory, econometric modeling, causal inference, and empirical testing of economic hypotheses"
    },
    "subfield:2003": {
      "kind": "subfield",
      "id": 2003,
      "parentKey": "field:20",
      "slug": "finance",
      "name": "Finance",
      "description": "The study of financial markets, institutions, and decision-making, including corporate finance, investments, financial derivatives, risk management, behavioral finance, and financial regulation"
    },
    "subfield:2100": {
      "kind": "subfield",
      "id": 2100,
      "parentKey": "field:21",
      "slug": "general-energy",
      "name": "General Energy",
      "description": "Comprehensive energy studies covering multiple energy sources and systems, including energy policy, economics, security, sustainability, and the integration of diverse energy technologies"
    },
    "subfield:2102": {
      "kind": "subfield",
      "id": 2102,
      "parentKey": "field:21",
      "slug": "energy-engineering-and-power-technology",
      "name": "Energy Engineering and Power Technology",
      "description": "The design and operation of energy conversion and power generation systems, including thermal power plants, renewable energy technologies, energy storage, smart grids, and energy efficiency optimization"
    },
    "subfield:2103": {
      "kind": "subfield",
      "id": 2103,
      "parentKey": "field:21",
      "slug": "fuel-technology",
      "name": "Fuel Technology",
      "description": "The production, processing, and utilization of fuels, including fossil fuels, biofuels, hydrogen, synthetic fuels, combustion technology, and the development of cleaner fuel alternatives"
    },
    "subfield:2104": {
      "kind": "subfield",
      "id": 2104,
      "parentKey": "field:21",
      "slug": "nuclear-energy-and-engineering",
      "name": "Nuclear Energy and Engineering",
      "description": "Nuclear power generation and applications, including reactor design, nuclear fuel cycle, radiation protection, fusion energy research, and the management of nuclear waste and decommissioning"
    },
    "subfield:2105": {
      "kind": "subfield",
      "id": 2105,
      "parentKey": "field:21",
      "slug": "renewable-energy-sustainability-and-the-environment",
      "name": "Renewable Energy, Sustainability and the Environment",
      "description": "Sustainable energy systems and technologies, including solar, wind, hydro, geothermal, and biomass energy, life cycle assessment, carbon mitigation, and the environmental impacts of energy systems"
    },
    "subfield:2200": {
      "kind": "subfield",
      "id": 2200,
      "parentKey": "field:22",
      "slug": "general-engineering",
      "name": "General Engineering",
      "description": "Interdisciplinary engineering research and education covering fundamental engineering principles, systems thinking, engineering design methodology, and cross-cutting engineering challenges"
    },
    "subfield:2202": {
      "kind": "subfield",
      "id": 2202,
      "parentKey": "field:22",
      "slug": "aerospace-engineering",
      "name": "Aerospace Engineering",
      "description": "The design and development of aircraft and spacecraft, including aerodynamics, propulsion, structures, avionics, orbital mechanics, and the engineering challenges of atmospheric and space flight"
    },
    "subfield:2203": {
      "kind": "subfield",
      "id": 2203,
      "parentKey": "field:22",
      "slug": "automotive-engineering",
      "name": "Automotive Engineering",
      "description": "The design and manufacturing of vehicles, including powertrains, chassis systems, vehicle dynamics, autonomous vehicles, electric vehicles, safety systems, and sustainable transportation technologies"
    },
    "subfield:2204": {
      "kind": "subfield",
      "id": 2204,
      "parentKey": "field:22",
      "slug": "biomedical-engineering",
      "name": "Biomedical Engineering",
      "description": "The application of engineering to medicine and biology, including medical devices, biomaterials, tissue engineering, medical imaging, biomechanics, and the development of diagnostic and therapeutic technologies"
    },
    "subfield:2205": {
      "kind": "subfield",
      "id": 2205,
      "parentKey": "field:22",
      "slug": "civil-and-structural-engineering",
      "name": "Civil and Structural Engineering",
      "description": "The design and analysis of infrastructure and structures, including bridges, buildings, dams, transportation systems, earthquake engineering, and the development of resilient civil infrastructure"
    },
    "subfield:2206": {
      "kind": "subfield",
      "id": 2206,
      "parentKey": "field:22",
      "slug": "computational-mechanics",
      "name": "Computational Mechanics",
      "description": "Numerical methods for solving mechanical problems, including finite element analysis, computational fluid dynamics, multiscale modeling, and the simulation of complex engineering systems"
    },
    "subfield:2207": {
      "kind": "subfield",
      "id": 2207,
      "parentKey": "field:22",
      "slug": "control-and-systems-engineering",
      "name": "Control and Systems Engineering",
      "description": "The design of control systems for dynamic processes, including feedback control, robotics, automation, adaptive systems, and the integration of sensors and actuators in intelligent systems"
    },
    "subfield:2208": {
      "kind": "subfield",
      "id": 2208,
      "parentKey": "field:22",
      "slug": "electrical-and-electronic-engineering",
      "name": "Electrical and Electronic Engineering",
      "description": "The study and application of electricity and electronics, including power systems, electronics, telecommunications, signal processing, electromagnetics, and the design of electrical devices and systems"
    },
    "subfield:2209": {
      "kind": "subfield",
      "id": 2209,
      "parentKey": "field:22",
      "slug": "industrial-and-manufacturing-engineering",
      "name": "Industrial and Manufacturing Engineering",
      "description": "The optimization of complex processes and systems, including production planning, quality control, supply chain management, lean manufacturing, automation, and Industry 4.0 technologies"
    },
    "subfield:2210": {
      "kind": "subfield",
      "id": 2210,
      "parentKey": "field:22",
      "slug": "mechanical-engineering",
      "name": "Mechanical Engineering",
      "description": "The design and analysis of mechanical systems, including thermodynamics, fluid mechanics, machine design, robotics, HVAC systems, and the development of innovative mechanical technologies"
    },
    "subfield:2211": {
      "kind": "subfield",
      "id": 2211,
      "parentKey": "field:22",
      "slug": "mechanics-of-materials",
      "name": "Mechanics of Materials",
      "description": "The behavior of solid materials under various conditions, including stress analysis, fracture mechanics, fatigue, composite materials, and the development of advanced structural materials"
    },
    "subfield:2212": {
      "kind": "subfield",
      "id": 2212,
      "parentKey": "field:22",
      "slug": "ocean-engineering",
      "name": "Ocean Engineering",
      "description": "Engineering for marine environments, including offshore structures, naval architecture, underwater vehicles, ocean renewable energy, coastal engineering, and marine technology systems"
    },
    "subfield:2213": {
      "kind": "subfield",
      "id": 2213,
      "parentKey": "field:22",
      "slug": "safety-risk-reliability-and-quality",
      "name": "Safety, Risk, Reliability and Quality",
      "description": "Engineering approaches to system safety and reliability, including risk assessment, failure analysis, quality assurance, human factors, and the design of fault-tolerant systems"
    },
    "subfield:2214": {
      "kind": "subfield",
      "id": 2214,
      "parentKey": "field:22",
      "slug": "media-technology",
      "name": "Media Technology",
      "description": "Engineering aspects of media production and distribution, including audio/video technology, streaming systems, virtual production, broadcast engineering, and emerging media platforms"
    },
    "subfield:2215": {
      "kind": "subfield",
      "id": 2215,
      "parentKey": "field:22",
      "slug": "building-and-construction",
      "name": "Building and Construction",
      "description": "Construction methods, materials, and management, including sustainable construction, building information modeling, construction safety, project management, and innovations in building technology"
    },
    "subfield:2216": {
      "kind": "subfield",
      "id": 2216,
      "parentKey": "field:22",
      "slug": "architecture",
      "name": "Architecture",
      "description": "The art and science of designing buildings and spaces, including architectural theory, sustainable design, urban planning, building technology, historic preservation, and the social impacts of built environments"
    },
    "subfield:2300": {
      "kind": "subfield",
      "id": 2300,
      "parentKey": "field:23",
      "slug": "general-environmental-science",
      "name": "General Environmental Science",
      "description": "Interdisciplinary research spanning multiple areas of environmental science that bridges traditional boundaries within this field"
    },
    "subfield:2302": {
      "kind": "subfield",
      "id": 2302,
      "parentKey": "field:23",
      "slug": "ecological-modeling",
      "name": "Ecological Modeling",
      "description": "Mathematical and computational approaches to understanding ecosystems, including population dynamics, food web models, ecosystem services valuation, and predictive modeling of ecological responses"
    },
    "subfield:2303": {
      "kind": "subfield",
      "id": 2303,
      "parentKey": "field:23",
      "slug": "ecology",
      "name": "Ecology",
      "description": "The study of interactions between organisms and their environment, including community ecology, ecosystem ecology, landscape ecology, conservation biology, and biodiversity patterns and processes"
    },
    "subfield:2304": {
      "kind": "subfield",
      "id": 2304,
      "parentKey": "field:23",
      "slug": "environmental-chemistry",
      "name": "Environmental Chemistry",
      "description": "Chemical processes in the environment, including pollutant fate and transport, atmospheric chemistry, aquatic chemistry, soil chemistry, and the development of green chemistry solutions"
    },
    "subfield:2305": {
      "kind": "subfield",
      "id": 2305,
      "parentKey": "field:23",
      "slug": "environmental-engineering",
      "name": "Environmental Engineering",
      "description": "Engineering solutions for environmental protection, including water and wastewater treatment, air pollution control, solid waste management, remediation technologies, and sustainable engineering design"
    },
    "subfield:2306": {
      "kind": "subfield",
      "id": 2306,
      "parentKey": "field:23",
      "slug": "global-and-planetary-change",
      "name": "Global and Planetary Change",
      "description": "Large-scale environmental changes, including climate change, biogeochemical cycles, land use change, sea level rise, and the impacts of human activities on Earth system processes"
    },
    "subfield:2307": {
      "kind": "subfield",
      "id": 2307,
      "parentKey": "field:23",
      "slug": "health-toxicology-and-mutagenesis",
      "name": "Health, Toxicology and Mutagenesis",
      "description": "Environmental impacts on human health, including exposure assessment, ecotoxicology, environmental epidemiology, risk assessment, and the effects of pollutants on genetic material"
    },
    "subfield:2308": {
      "kind": "subfield",
      "id": 2308,
      "parentKey": "field:23",
      "slug": "management-monitoring-policy-and-law",
      "name": "Management, Monitoring, Policy and Law",
      "description": "Environmental governance and management, including environmental policy, regulation, monitoring systems, environmental impact assessment, and international environmental agreements"
    },
    "subfield:2309": {
      "kind": "subfield",
      "id": 2309,
      "parentKey": "field:23",
      "slug": "nature-and-landscape-conservation",
      "name": "Nature and Landscape Conservation",
      "description": "Conservation science and practice, including protected area management, habitat restoration, species conservation, landscape ecology, and the integration of human activities with conservation goals"
    },
    "subfield:2310": {
      "kind": "subfield",
      "id": 2310,
      "parentKey": "field:23",
      "slug": "pollution",
      "name": "Pollution",
      "description": "The study and control of environmental contamination, including air, water, and soil pollution, noise pollution, plastic pollution, pollution prevention, and the development of cleanup technologies"
    },
    "subfield:2311": {
      "kind": "subfield",
      "id": 2311,
      "parentKey": "field:23",
      "slug": "industrial-and-manufacturing-engineering",
      "name": "Industrial and Manufacturing Engineering",
      "description": "Sustainable manufacturing and industrial ecology, including cleaner production, life cycle assessment, circular economy, eco-design, and the environmental optimization of industrial processes"
    },
    "subfield:2312": {
      "kind": "subfield",
      "id": 2312,
      "parentKey": "field:23",
      "slug": "water-science-and-technology",
      "name": "Water Science and Technology",
      "description": "All aspects of water resources, including hydrology, water quality, aquatic ecosystems, water treatment technologies, water resource management, and solutions for water scarcity"
    },
    "subfield:2400": {
      "kind": "subfield",
      "id": 2400,
      "parentKey": "field:24",
      "slug": "general-immunology-and-microbiology",
      "name": "General Immunology and Microbiology",
      "description": "Interdisciplinary research spanning multiple areas of immunology and microbiology that bridges traditional boundaries within this field"
    },
    "subfield:2402": {
      "kind": "subfield",
      "id": 2402,
      "parentKey": "field:24",
      "slug": "applied-microbiology-and-biotechnology",
      "name": "Applied Microbiology and Biotechnology",
      "description": "The practical application of microorganisms, including industrial fermentation, bioremediation, microbial production of chemicals and materials, probiotics, and microbial biotechnology innovations"
    },
    "subfield:2403": {
      "kind": "subfield",
      "id": 2403,
      "parentKey": "field:24",
      "slug": "immunology",
      "name": "Immunology",
      "description": "The study of immune systems in all organisms, including innate and adaptive immunity, immunological disorders, vaccines, transplantation immunology, and therapeutic immunology approaches"
    },
    "subfield:2404": {
      "kind": "subfield",
      "id": 2404,
      "parentKey": "field:24",
      "slug": "microbiology",
      "name": "Microbiology",
      "description": "The study of microorganisms, including bacteria, viruses, fungi, and protozoa, their genetics, physiology, ecology, evolution, and roles in health, disease, and the environment"
    },
    "subfield:2405": {
      "kind": "subfield",
      "id": 2405,
      "parentKey": "field:24",
      "slug": "parasitology",
      "name": "Parasitology",
      "description": "The study of parasites and parasitic diseases, including parasite biology, host-parasite interactions, epidemiology of parasitic infections, and the development of antiparasitic interventions"
    },
    "subfield:2406": {
      "kind": "subfield",
      "id": 2406,
      "parentKey": "field:24",
      "slug": "virology",
      "name": "Virology",
      "description": "The study of viruses and viral diseases, including viral structure, replication, pathogenesis, evolution, antiviral drugs, viral vectors, and emerging viral threats to human and animal health"
    },
    "subfield:2500": {
      "kind": "subfield",
      "id": 2500,
      "parentKey": "field:25",
      "slug": "general-materials-science",
      "name": "General Materials Science",
      "description": "Fundamental materials research spanning multiple material classes, including materials characterization, processing-structure-property relationships, and cross-cutting materials phenomena"
    },
    "subfield:2502": {
      "kind": "subfield",
      "id": 2502,
      "parentKey": "field:25",
      "slug": "biomaterials",
      "name": "Biomaterials",
      "description": "Materials for medical and biological applications, including implants, tissue engineering scaffolds, drug delivery systems, biocompatibility, and the interaction between materials and biological systems"
    },
    "subfield:2503": {
      "kind": "subfield",
      "id": 2503,
      "parentKey": "field:25",
      "slug": "ceramics-and-composites",
      "name": "Ceramics and Composites",
      "description": "Advanced ceramic materials and composite systems, including structural ceramics, functional ceramics, fiber-reinforced composites, nanocomposites, and high-temperature materials"
    },
    "subfield:2504": {
      "kind": "subfield",
      "id": 2504,
      "parentKey": "field:25",
      "slug": "electronic-optical-and-magnetic-materials",
      "name": "Electronic, Optical and Magnetic Materials",
      "description": "Materials for electronic and photonic applications, including semiconductors, superconductors, magnetic materials, photonic crystals, metamaterials, and quantum materials"
    },
    "subfield:2505": {
      "kind": "subfield",
      "id": 2505,
      "parentKey": "field:25",
      "slug": "materials-chemistry",
      "name": "Materials Chemistry",
      "description": "Chemical approaches to materials synthesis and modification, including sol-gel processing, self-assembly, surface chemistry, catalytic materials, and chemically derived nanomaterials"
    },
    "subfield:2506": {
      "kind": "subfield",
      "id": 2506,
      "parentKey": "field:25",
      "slug": "metals-and-alloys",
      "name": "Metals and Alloys",
      "description": "Metallic materials and their properties, including alloy design, metallurgy, corrosion, metal processing, high-entropy alloys, and advanced metallic materials for structural applications"
    },
    "subfield:2507": {
      "kind": "subfield",
      "id": 2507,
      "parentKey": "field:25",
      "slug": "polymers-and-plastics",
      "name": "Polymers and Plastics",
      "description": "Synthetic and natural polymeric materials, including polymer synthesis, characterization, processing, polymer physics, biodegradable polymers, and functional polymer systems"
    },
    "subfield:2508": {
      "kind": "subfield",
      "id": 2508,
      "parentKey": "field:25",
      "slug": "surfaces-coatings-and-films",
      "name": "Surfaces, Coatings and Films",
      "description": "Surface engineering and thin film technologies, including surface modification, protective coatings, functional films, tribology, and advanced deposition techniques"
    },
    "subfield:2600": {
      "kind": "subfield",
      "id": 2600,
      "parentKey": "field:26",
      "slug": "general-mathematics",
      "name": "General Mathematics",
      "description": "Interdisciplinary research spanning multiple areas of mathematics that bridges traditional boundaries within this field"
    },
    "subfield:2602": {
      "kind": "subfield",
      "id": 2602,
      "parentKey": "field:26",
      "slug": "algebra-and-number-theory",
      "name": "Algebra and Number Theory",
      "description": "Abstract algebraic structures and properties of integers, including groups, rings, fields, algebraic geometry, arithmetic geometry, and applications to cryptography and coding theory"
    },
    "subfield:2604": {
      "kind": "subfield",
      "id": 2604,
      "parentKey": "field:26",
      "slug": "applied-mathematics",
      "name": "Applied Mathematics",
      "description": "Mathematical methods for real-world problems, including differential equations, optimization, mathematical modeling, dynamical systems, and applications in science, engineering, and industry"
    },
    "subfield:2605": {
      "kind": "subfield",
      "id": 2605,
      "parentKey": "field:26",
      "slug": "computational-mathematics",
      "name": "Computational Mathematics",
      "description": "Numerical algorithms and computational techniques, including numerical analysis, scientific computing, high-performance computing, computational algebra, and mathematical software development"
    },
    "subfield:2607": {
      "kind": "subfield",
      "id": 2607,
      "parentKey": "field:26",
      "slug": "discrete-mathematics-and-combinatorics",
      "name": "Discrete Mathematics and Combinatorics",
      "description": "Mathematics of discrete structures, including graph theory, combinatorial optimization, coding theory, discrete geometry, and applications to computer science and operations research"
    },
    "subfield:2608": {
      "kind": "subfield",
      "id": 2608,
      "parentKey": "field:26",
      "slug": "geometry-and-topology",
      "name": "Geometry and Topology",
      "description": "The study of shape, space, and continuous deformations, including differential geometry, algebraic topology, geometric analysis, and applications to physics and data analysis"
    },
    "subfield:2610": {
      "kind": "subfield",
      "id": 2610,
      "parentKey": "field:26",
      "slug": "mathematical-physics",
      "name": "Mathematical Physics",
      "description": "Mathematical foundations of physical theories, including quantum mechanics, statistical mechanics, general relativity, string theory, and the development of rigorous mathematical frameworks for physics"
    },
    "subfield:2611": {
      "kind": "subfield",
      "id": 2611,
      "parentKey": "field:26",
      "slug": "modeling-and-simulation",
      "name": "Modeling and Simulation",
      "description": "Mathematical representation and computer simulation of complex systems, including agent-based models, Monte Carlo methods, system dynamics, and validation of computational models"
    },
    "subfield:2612": {
      "kind": "subfield",
      "id": 2612,
      "parentKey": "field:26",
      "slug": "numerical-analysis",
      "name": "Numerical Analysis",
      "description": "The development and analysis of algorithms for numerical computation, including error analysis, stability, convergence, and efficient methods for solving mathematical problems computationally"
    },
    "subfield:2613": {
      "kind": "subfield",
      "id": 2613,
      "parentKey": "field:26",
      "slug": "statistics-and-probability",
      "name": "Statistics and Probability",
      "description": "Mathematical frameworks for data analysis and uncertainty, including statistical theory, probability theory, stochastic processes, statistical inference, and applications to data science"
    },
    "subfield:2614": {
      "kind": "subfield",
      "id": 2614,
      "parentKey": "field:26",
      "slug": "theoretical-computer-science",
      "name": "Theoretical Computer Science",
      "description": "Mathematical aspects of computation, including algorithms, computational complexity, automata theory, formal methods, quantum computing theory, and the foundations of computer science"
    },
    "subfield:2700": {
      "kind": "subfield",
      "id": 2700,
      "parentKey": "field:27",
      "slug": "general-medicine",
      "name": "General Medicine",
      "description": "Interdisciplinary research spanning multiple areas of medicine that bridges traditional boundaries within this field"
    },
    "subfield:2702": {
      "kind": "subfield",
      "id": 2702,
      "parentKey": "field:27",
      "slug": "anatomy",
      "name": "Anatomy",
      "description": "The structure of the human body, including gross anatomy, histology, embryology, neuroanatomy, and the application of anatomical knowledge to clinical practice and medical education"
    },
    "subfield:2703": {
      "kind": "subfield",
      "id": 2703,
      "parentKey": "field:27",
      "slug": "anesthesiology-and-pain-medicine",
      "name": "Anesthesiology and Pain Medicine",
      "description": "The practice of anesthesia and pain management, including perioperative care, regional anesthesia, critical care, chronic pain treatment, and the development of new analgesic approaches"
    },
    "subfield:2704": {
      "kind": "subfield",
      "id": 2704,
      "parentKey": "field:27",
      "slug": "biochemistry",
      "name": "Biochemistry",
      "description": "The chemical basis of physiological and pathological processes, including clinical biochemistry, metabolic pathways, molecular diagnostics, and the biochemical mechanisms of disease"
    },
    "subfield:2705": {
      "kind": "subfield",
      "id": 2705,
      "parentKey": "field:27",
      "slug": "cardiology-and-cardiovascular-medicine",
      "name": "Cardiology and Cardiovascular Medicine",
      "description": "The study and treatment of heart and vascular diseases, including coronary artery disease, heart failure, arrhythmias, interventional cardiology, and cardiovascular prevention"
    },
    "subfield:2706": {
      "kind": "subfield",
      "id": 2706,
      "parentKey": "field:27",
      "slug": "critical-care-and-intensive-care-medicine",
      "name": "Critical Care and Intensive Care Medicine",
      "description": "The management of critically ill patients, including mechanical ventilation, hemodynamic support, sepsis management, organ failure, and innovations in intensive care unit practices"
    },
    "subfield:2707": {
      "kind": "subfield",
      "id": 2707,
      "parentKey": "field:27",
      "slug": "complementary-and-alternative-medicine",
      "name": "Complementary and alternative medicine",
      "description": "Non-conventional medical practices, including traditional medicine, acupuncture, herbal medicine, mind-body therapies, and the integration of complementary approaches with conventional medicine"
    },
    "subfield:2708": {
      "kind": "subfield",
      "id": 2708,
      "parentKey": "field:27",
      "slug": "dermatology",
      "name": "Dermatology",
      "description": "The diagnosis and treatment of skin disorders, including inflammatory skin diseases, skin cancer, cosmetic dermatology, pediatric dermatology, and dermatologic surgery"
    },
    "subfield:2711": {
      "kind": "subfield",
      "id": 2711,
      "parentKey": "field:27",
      "slug": "emergency-medicine",
      "name": "Emergency Medicine",
      "description": "Acute care medicine in emergency settings, including trauma management, resuscitation, emergency procedures, disaster medicine, and the organization of emergency medical services"
    },
    "subfield:2712": {
      "kind": "subfield",
      "id": 2712,
      "parentKey": "field:27",
      "slug": "endocrinology-diabetes-and-metabolism",
      "name": "Endocrinology, Diabetes and Metabolism",
      "description": "Hormonal disorders and metabolic diseases, including diabetes mellitus, thyroid disorders, obesity, metabolic syndrome, and the endocrine regulation of metabolism"
    },
    "subfield:2713": {
      "kind": "subfield",
      "id": 2713,
      "parentKey": "field:27",
      "slug": "epidemiology",
      "name": "Epidemiology",
      "description": "The patterns and causes of disease in populations, including disease surveillance, outbreak investigation, clinical trials, health disparities, and the development of public health interventions"
    },
    "subfield:2714": {
      "kind": "subfield",
      "id": 2714,
      "parentKey": "field:27",
      "slug": "family-practice",
      "name": "Family Practice",
      "description": "Comprehensive primary care across the lifespan, including preventive medicine, chronic disease management, patient-centered care, and the coordination of healthcare services"
    },
    "subfield:2715": {
      "kind": "subfield",
      "id": 2715,
      "parentKey": "field:27",
      "slug": "gastroenterology",
      "name": "Gastroenterology",
      "description": "Diseases of the digestive system, including inflammatory bowel disease, liver disease, gastrointestinal cancers, endoscopy, and functional gastrointestinal disorders"
    },
    "subfield:2716": {
      "kind": "subfield",
      "id": 2716,
      "parentKey": "field:27",
      "slug": "genetics",
      "name": "Genetics",
      "description": "Medical genetics and genomic medicine, including genetic testing, inherited diseases, pharmacogenomics, genetic counseling, and the application of genomics to personalized medicine"
    },
    "subfield:2717": {
      "kind": "subfield",
      "id": 2717,
      "parentKey": "field:27",
      "slug": "geriatrics-and-gerontology",
      "name": "Geriatrics and Gerontology",
      "description": "Healthcare for older adults, including age-related diseases, frailty, cognitive decline, polypharmacy, long-term care, and strategies for healthy aging"
    },
    "subfield:2718": {
      "kind": "subfield",
      "id": 2718,
      "parentKey": "field:27",
      "slug": "health-informatics",
      "name": "Health Informatics",
      "description": "Information technology in healthcare, including electronic health records, clinical decision support, telemedicine, health data analytics, and the use of AI in medicine"
    },
    "subfield:2720": {
      "kind": "subfield",
      "id": 2720,
      "parentKey": "field:27",
      "slug": "hematology",
      "name": "Hematology",
      "description": "Blood disorders and diseases, including anemia, bleeding disorders, thrombosis, hematologic malignancies, transfusion medicine, and stem cell transplantation"
    },
    "subfield:2721": {
      "kind": "subfield",
      "id": 2721,
      "parentKey": "field:27",
      "slug": "hepatology",
      "name": "Hepatology",
      "description": "Liver diseases and disorders, including viral hepatitis, cirrhosis, fatty liver disease, liver cancer, liver transplantation, and the management of portal hypertension"
    },
    "subfield:2723": {
      "kind": "subfield",
      "id": 2723,
      "parentKey": "field:27",
      "slug": "immunology-and-allergy",
      "name": "Immunology and Allergy",
      "description": "Immune system disorders and allergic diseases, including autoimmune diseases, immunodeficiencies, allergic rhinitis, asthma, anaphylaxis, and immunotherapy approaches"
    },
    "subfield:2724": {
      "kind": "subfield",
      "id": 2724,
      "parentKey": "field:27",
      "slug": "internal-medicine",
      "name": "Internal Medicine",
      "description": "Comprehensive adult medicine, including diagnosis and management of complex medical conditions, hospital medicine, preventive care, and the coordination of subspecialty care"
    },
    "subfield:2725": {
      "kind": "subfield",
      "id": 2725,
      "parentKey": "field:27",
      "slug": "infectious-diseases",
      "name": "Infectious Diseases",
      "description": "The prevention and treatment of infections, including antimicrobial therapy, emerging infectious diseases, hospital-acquired infections, tropical medicine, and vaccine development"
    },
    "subfield:2726": {
      "kind": "subfield",
      "id": 2726,
      "parentKey": "field:27",
      "slug": "microbiology",
      "name": "Microbiology",
      "description": "Medical microbiology and infectious agents, including bacterial, viral, fungal, and parasitic pathogens, antimicrobial resistance, diagnostic microbiology, and infection control"
    },
    "subfield:2727": {
      "kind": "subfield",
      "id": 2727,
      "parentKey": "field:27",
      "slug": "nephrology",
      "name": "Nephrology",
      "description": "Kidney diseases and disorders, including chronic kidney disease, acute kidney injury, dialysis, kidney transplantation, electrolyte disorders, and hypertension"
    },
    "subfield:2728": {
      "kind": "subfield",
      "id": 2728,
      "parentKey": "field:27",
      "slug": "neurology",
      "name": "Neurology",
      "description": "Diseases of the nervous system, including stroke, epilepsy, movement disorders, neurodegenerative diseases, headaches, and the application of neuroimaging to diagnosis"
    },
    "subfield:2729": {
      "kind": "subfield",
      "id": 2729,
      "parentKey": "field:27",
      "slug": "obstetrics-and-gynecology",
      "name": "Obstetrics and Gynecology",
      "description": "Women's reproductive health, including pregnancy care, childbirth, gynecologic disorders, reproductive endocrinology, gynecologic oncology, and maternal-fetal medicine"
    },
    "subfield:2730": {
      "kind": "subfield",
      "id": 2730,
      "parentKey": "field:27",
      "slug": "oncology",
      "name": "Oncology",
      "description": "Cancer diagnosis and treatment, including medical oncology, radiation oncology, surgical oncology, cancer immunotherapy, precision oncology, and palliative care"
    },
    "subfield:2731": {
      "kind": "subfield",
      "id": 2731,
      "parentKey": "field:27",
      "slug": "ophthalmology",
      "name": "Ophthalmology",
      "description": "Eye diseases and vision disorders, including cataracts, glaucoma, retinal diseases, refractive surgery, pediatric ophthalmology, and advances in ophthalmic surgery"
    },
    "subfield:2732": {
      "kind": "subfield",
      "id": 2732,
      "parentKey": "field:27",
      "slug": "orthopedics-and-sports-medicine",
      "name": "Orthopedics and Sports Medicine",
      "description": "Musculoskeletal disorders and injuries, including joint replacement, spine surgery, sports injuries, trauma surgery, pediatric orthopedics, and rehabilitation"
    },
    "subfield:2733": {
      "kind": "subfield",
      "id": 2733,
      "parentKey": "field:27",
      "slug": "otorhinolaryngology",
      "name": "Otorhinolaryngology",
      "description": "Ear, nose, and throat disorders, including hearing loss, sinusitis, voice disorders, head and neck cancer, pediatric ENT, and advances in ENT surgery"
    },
    "subfield:2734": {
      "kind": "subfield",
      "id": 2734,
      "parentKey": "field:27",
      "slug": "pathology-and-forensic-medicine",
      "name": "Pathology and Forensic Medicine",
      "description": "Disease diagnosis through laboratory analysis, including anatomic pathology, clinical pathology, molecular pathology, autopsy, and the application of pathology to legal investigations"
    },
    "subfield:2735": {
      "kind": "subfield",
      "id": 2735,
      "parentKey": "field:27",
      "slug": "pediatrics-perinatology-and-child-health",
      "name": "Pediatrics, Perinatology and Child Health",
      "description": "Healthcare for infants, children, and adolescents, including neonatology, developmental pediatrics, pediatric subspecialties, childhood vaccinations, and adolescent medicine"
    },
    "subfield:2736": {
      "kind": "subfield",
      "id": 2736,
      "parentKey": "field:27",
      "slug": "pharmacology",
      "name": "Pharmacology",
      "description": "Drug action and therapeutics, including clinical pharmacology, drug development, pharmacokinetics, pharmacodynamics, adverse drug reactions, and personalized medicine approaches"
    },
    "subfield:2737": {
      "kind": "subfield",
      "id": 2737,
      "parentKey": "field:27",
      "slug": "physiology",
      "name": "Physiology",
      "description": "Normal body function and regulation, including cardiovascular physiology, respiratory physiology, neurophysiology, exercise physiology, and the physiological basis of disease"
    },
    "subfield:2738": {
      "kind": "subfield",
      "id": 2738,
      "parentKey": "field:27",
      "slug": "psychiatry-and-mental-health",
      "name": "Psychiatry and Mental health",
      "description": "Mental health disorders and treatment, including mood disorders, psychotic disorders, anxiety disorders, psychotherapy, psychopharmacology, and community mental health"
    },
    "subfield:2739": {
      "kind": "subfield",
      "id": 2739,
      "parentKey": "field:27",
      "slug": "public-health-environmental-and-occupational-health",
      "name": "Public Health, Environmental and Occupational Health",
      "description": "Population health and prevention, including health promotion, disease prevention, environmental health hazards, occupational safety, health policy, and global health initiatives"
    },
    "subfield:2740": {
      "kind": "subfield",
      "id": 2740,
      "parentKey": "field:27",
      "slug": "pulmonary-and-respiratory-medicine",
      "name": "Pulmonary and Respiratory Medicine",
      "description": "Lung diseases and respiratory disorders, including asthma, COPD, pneumonia, lung cancer, sleep disorders, pulmonary hypertension, and critical care pulmonology"
    },
    "subfield:2741": {
      "kind": "subfield",
      "id": 2741,
      "parentKey": "field:27",
      "slug": "radiology-nuclear-medicine-and-imaging",
      "name": "Radiology, Nuclear Medicine and Imaging",
      "description": "Medical imaging and image-guided procedures, including diagnostic radiology, interventional radiology, nuclear medicine, radiation therapy planning, and advances in imaging technology"
    },
    "subfield:2742": {
      "kind": "subfield",
      "id": 2742,
      "parentKey": "field:27",
      "slug": "rehabilitation",
      "name": "Rehabilitation",
      "description": "Restoration of function after illness or injury, including physical medicine, occupational therapy, speech therapy, cardiac rehabilitation, and assistive technology"
    },
    "subfield:2743": {
      "kind": "subfield",
      "id": 2743,
      "parentKey": "field:27",
      "slug": "reproductive-medicine",
      "name": "Reproductive Medicine",
      "description": "Fertility and reproductive health, including infertility treatment, assisted reproductive technology, reproductive endocrinology, contraception, and preservation of fertility"
    },
    "subfield:2745": {
      "kind": "subfield",
      "id": 2745,
      "parentKey": "field:27",
      "slug": "rheumatology",
      "name": "Rheumatology",
      "description": "Autoimmune and inflammatory joint diseases, including rheumatoid arthritis, lupus, osteoarthritis, gout, vasculitis, and the development of targeted therapies"
    },
    "subfield:2746": {
      "kind": "subfield",
      "id": 2746,
      "parentKey": "field:27",
      "slug": "surgery",
      "name": "Surgery",
      "description": "Surgical treatment of disease and injury, including general surgery, minimally invasive surgery, robotic surgery, transplant surgery, surgical oncology, and perioperative care"
    },
    "subfield:2747": {
      "kind": "subfield",
      "id": 2747,
      "parentKey": "field:27",
      "slug": "transplantation",
      "name": "Transplantation",
      "description": "Organ and tissue transplantation, including donor selection, immunosuppression, rejection prevention, organ preservation, xenotransplantation, and transplant outcomes"
    },
    "subfield:2748": {
      "kind": "subfield",
      "id": 2748,
      "parentKey": "field:27",
      "slug": "urology",
      "name": "Urology",
      "description": "Urinary tract and male reproductive disorders, including prostate disease, kidney stones, bladder cancer, erectile dysfunction, pediatric urology, and urologic surgery"
    },
    "subfield:2800": {
      "kind": "subfield",
      "id": 2800,
      "parentKey": "field:28",
      "slug": "general-neuroscience",
      "name": "General Neuroscience",
      "description": "Interdisciplinary research spanning multiple areas of neuroscience that bridges traditional boundaries within this field"
    },
    "subfield:2802": {
      "kind": "subfield",
      "id": 2802,
      "parentKey": "field:28",
      "slug": "behavioral-neuroscience",
      "name": "Behavioral Neuroscience",
      "description": "Neural mechanisms underlying behavior, including learning, memory, motivation, emotion, addiction, and the use of animal models to understand human behavioral disorders"
    },
    "subfield:2803": {
      "kind": "subfield",
      "id": 2803,
      "parentKey": "field:28",
      "slug": "biological-psychiatry",
      "name": "Biological Psychiatry",
      "description": "The biological basis of psychiatric disorders, including neurotransmitter systems, brain imaging in psychiatry, genetic factors, psychopharmacology, and biomarkers for mental illness"
    },
    "subfield:2804": {
      "kind": "subfield",
      "id": 2804,
      "parentKey": "field:28",
      "slug": "cellular-and-molecular-neuroscience",
      "name": "Cellular and Molecular Neuroscience",
      "description": "Molecular and cellular mechanisms of nervous system function, including synaptic transmission, ion channels, neurotransmitter receptors, signal transduction, and neuronal development"
    },
    "subfield:2805": {
      "kind": "subfield",
      "id": 2805,
      "parentKey": "field:28",
      "slug": "cognitive-neuroscience",
      "name": "Cognitive Neuroscience",
      "description": "Neural basis of cognitive functions, including attention, perception, language, decision-making, executive function, and the use of neuroimaging to study human cognition"
    },
    "subfield:2806": {
      "kind": "subfield",
      "id": 2806,
      "parentKey": "field:28",
      "slug": "developmental-neuroscience",
      "name": "Developmental Neuroscience",
      "description": "Development of the nervous system, including neurogenesis, axon guidance, synapse formation, neural plasticity, and developmental disorders of the nervous system"
    },
    "subfield:2807": {
      "kind": "subfield",
      "id": 2807,
      "parentKey": "field:28",
      "slug": "endocrine-and-autonomic-systems",
      "name": "Endocrine and Autonomic Systems",
      "description": "Neuroendocrine regulation and autonomic function, including stress responses, circadian rhythms, autonomic disorders, and the interaction between the nervous and endocrine systems"
    },
    "subfield:2808": {
      "kind": "subfield",
      "id": 2808,
      "parentKey": "field:28",
      "slug": "neurology",
      "name": "Neurology",
      "description": "Clinical neuroscience and neurological disorders, including neurodegeneration, neuroimmunology, neuromuscular diseases, and translational approaches to neurological treatment"
    },
    "subfield:2809": {
      "kind": "subfield",
      "id": 2809,
      "parentKey": "field:28",
      "slug": "sensory-systems",
      "name": "Sensory Systems",
      "description": "Neural processing of sensory information, including vision, hearing, touch, taste, smell, pain perception, and the development of sensory prosthetics and interfaces"
    },
    "subfield:2900": {
      "kind": "subfield",
      "id": 2900,
      "parentKey": "field:29",
      "slug": "general-nursing",
      "name": "General Nursing",
      "description": "Interdisciplinary research spanning multiple areas of nursing that bridges traditional boundaries within this field"
    },
    "subfield:2910": {
      "kind": "subfield",
      "id": 2910,
      "parentKey": "field:29",
      "slug": "issues-ethics-and-legal-aspects",
      "name": "Issues, ethics and legal aspects",
      "description": "Ethical and legal considerations in nursing practice, including patient rights, informed consent, end-of-life care, professional ethics, and healthcare law affecting nursing"
    },
    "subfield:2911": {
      "kind": "subfield",
      "id": 2911,
      "parentKey": "field:29",
      "slug": "leadership-and-management",
      "name": "Leadership and Management",
      "description": "Nursing leadership and healthcare management, including nurse management, healthcare quality improvement, organizational behavior, change management, and nursing workforce development"
    },
    "subfield:2916": {
      "kind": "subfield",
      "id": 2916,
      "parentKey": "field:29",
      "slug": "nutrition-and-dietetics",
      "name": "Nutrition and Dietetics",
      "description": "Nutritional science and dietary management, including clinical nutrition, community nutrition, food service management, nutrition counseling, and the role of diet in health and disease"
    },
    "subfield:2922": {
      "kind": "subfield",
      "id": 2922,
      "parentKey": "field:29",
      "slug": "research-and-theory",
      "name": "Research and Theory",
      "description": "Nursing research methodology and theoretical frameworks, including evidence-based practice, nursing theories, research design, qualitative and quantitative methods, and knowledge translation"
    },
    "subfield:3000": {
      "kind": "subfield",
      "id": 3000,
      "parentKey": "field:30",
      "slug": "general-pharmacology-toxicology-and-pharmaceutics",
      "name": "General Pharmacology, Toxicology and Pharmaceutics",
      "description": "Interdisciplinary research spanning multiple areas of pharmacology, toxicology and pharmaceutics that bridges traditional boundaries within this field"
    },
    "subfield:3002": {
      "kind": "subfield",
      "id": 3002,
      "parentKey": "field:30",
      "slug": "drug-discovery",
      "name": "Drug Discovery",
      "description": "The identification and development of new therapeutic compounds, including target identification, lead optimization, high-throughput screening, and computational drug design"
    },
    "subfield:3003": {
      "kind": "subfield",
      "id": 3003,
      "parentKey": "field:30",
      "slug": "pharmaceutical-science",
      "name": "Pharmaceutical Science",
      "description": "Drug formulation and delivery, including pharmaceutics, pharmacokinetics, drug stability, controlled release systems, and the development of novel drug delivery technologies"
    },
    "subfield:3004": {
      "kind": "subfield",
      "id": 3004,
      "parentKey": "field:30",
      "slug": "pharmacology",
      "name": "Pharmacology",
      "description": "Drug action and effects on biological systems, including molecular pharmacology, neuropharmacology, cardiovascular pharmacology, drug-receptor interactions, and adverse drug reactions"
    },
    "subfield:3005": {
      "kind": "subfield",
      "id": 3005,
      "parentKey": "field:30",
      "slug": "toxicology",
      "name": "Toxicology",
      "description": "The study of adverse effects of chemicals, including mechanisms of toxicity, risk assessment, environmental toxicology, forensic toxicology, and regulatory toxicology"
    },
    "subfield:3100": {
      "kind": "subfield",
      "id": 3100,
      "parentKey": "field:31",
      "slug": "general-physics-and-astronomy",
      "name": "General Physics and Astronomy",
      "description": "Interdisciplinary research spanning multiple areas of physics and astronomy that bridges traditional boundaries within this field"
    },
    "subfield:3102": {
      "kind": "subfield",
      "id": 3102,
      "parentKey": "field:31",
      "slug": "acoustics-and-ultrasonics",
      "name": "Acoustics and Ultrasonics",
      "description": "The physics of sound and ultrasound, including wave propagation, acoustic materials, noise control, ultrasonic imaging, acoustic metamaterials, and applications in medicine and industry"
    },
    "subfield:3103": {
      "kind": "subfield",
      "id": 3103,
      "parentKey": "field:31",
      "slug": "astronomy-and-astrophysics",
      "name": "Astronomy and Astrophysics",
      "description": "The study of celestial objects and cosmic phenomena, including stellar evolution, galaxies, cosmology, exoplanets, gravitational waves, and observational astronomy techniques"
    },
    "subfield:3104": {
      "kind": "subfield",
      "id": 3104,
      "parentKey": "field:31",
      "slug": "condensed-matter-physics",
      "name": "Condensed Matter Physics",
      "description": "The physics of solid and liquid matter, including semiconductors, superconductors, magnetism, phase transitions, nanophysics, and quantum materials"
    },
    "subfield:3105": {
      "kind": "subfield",
      "id": 3105,
      "parentKey": "field:31",
      "slug": "instrumentation",
      "name": "Instrumentation",
      "description": "Scientific instrument development and measurement techniques, including detectors, sensors, imaging systems, precision measurement, and instrumentation for research facilities"
    },
    "subfield:3106": {
      "kind": "subfield",
      "id": 3106,
      "parentKey": "field:31",
      "slug": "nuclear-and-high-energy-physics",
      "name": "Nuclear and High Energy Physics",
      "description": "Fundamental particles and nuclear physics, including particle accelerators, quarks and leptons, nuclear structure, particle detectors, and the search for new physics"
    },
    "subfield:3107": {
      "kind": "subfield",
      "id": 3107,
      "parentKey": "field:31",
      "slug": "atomic-and-molecular-physics-and-optics",
      "name": "Atomic and Molecular Physics, and Optics",
      "description": "The physics of atoms, molecules, and light, including quantum optics, laser physics, spectroscopy, photonics, quantum information, and optical technologies"
    },
    "subfield:3108": {
      "kind": "subfield",
      "id": 3108,
      "parentKey": "field:31",
      "slug": "radiation",
      "name": "Radiation",
      "description": "The physics and applications of ionizing radiation, including radiation detection, dosimetry, radiation therapy, radiation protection, and nuclear medicine physics"
    },
    "subfield:3109": {
      "kind": "subfield",
      "id": 3109,
      "parentKey": "field:31",
      "slug": "statistical-and-nonlinear-physics",
      "name": "Statistical and Nonlinear Physics",
      "description": "Complex systems and statistical physics, including chaos theory, complex networks, soft matter physics, biophysics, and emergent phenomena in many-body systems"
    },
    "subfield:3200": {
      "kind": "subfield",
      "id": 3200,
      "parentKey": "field:32",
      "slug": "general-psychology",
      "name": "General Psychology",
      "description": "Broad psychological topics spanning multiple subfields, including psychological theory, history of psychology, research methods, and integrative approaches to understanding behavior"
    },
    "subfield:3202": {
      "kind": "subfield",
      "id": 3202,
      "parentKey": "field:32",
      "slug": "applied-psychology",
      "name": "Applied Psychology",
      "description": "Practical applications of psychological principles, including industrial-organizational psychology, forensic psychology, sport psychology, environmental psychology, and consumer psychology"
    },
    "subfield:3203": {
      "kind": "subfield",
      "id": 3203,
      "parentKey": "field:32",
      "slug": "clinical-psychology",
      "name": "Clinical Psychology",
      "description": "Assessment and treatment of mental health disorders, including psychotherapy, psychological testing, clinical interventions, evidence-based treatments, and mental health services"
    },
    "subfield:3204": {
      "kind": "subfield",
      "id": 3204,
      "parentKey": "field:32",
      "slug": "developmental-and-educational-psychology",
      "name": "Developmental and Educational Psychology",
      "description": "Human development and learning across the lifespan, including cognitive development, social development, educational interventions, learning disabilities, and school psychology"
    },
    "subfield:3205": {
      "kind": "subfield",
      "id": 3205,
      "parentKey": "field:32",
      "slug": "experimental-and-cognitive-psychology",
      "name": "Experimental and Cognitive Psychology",
      "description": "Basic psychological processes, including perception, attention, memory, thinking, problem-solving, language processing, and experimental methods in psychology"
    },
    "subfield:3206": {
      "kind": "subfield",
      "id": 3206,
      "parentKey": "field:32",
      "slug": "neuropsychology-and-physiological-psychology",
      "name": "Neuropsychology and Physiological Psychology",
      "description": "Brain-behavior relationships, including cognitive neuropsychology, clinical neuropsychology, psychophysiology, brain imaging in psychology, and biological bases of behavior"
    },
    "subfield:3207": {
      "kind": "subfield",
      "id": 3207,
      "parentKey": "field:32",
      "slug": "social-psychology",
      "name": "Social Psychology",
      "description": "How people think about and interact with others, including attitudes, social cognition, group dynamics, prejudice, interpersonal relationships, and cultural psychology"
    },
    "subfield:3300": {
      "kind": "subfield",
      "id": 3300,
      "parentKey": "field:33",
      "slug": "general-social-sciences",
      "name": "General Social Sciences",
      "description": "Interdisciplinary social science research, including mixed methods approaches, social theory, comparative studies, and research addressing complex social issues"
    },
    "subfield:3302": {
      "kind": "subfield",
      "id": 3302,
      "parentKey": "field:33",
      "slug": "archeology",
      "name": "Archeology",
      "description": "The study of human past through material remains, including excavation methods, artifact analysis, cultural heritage management, and reconstructing ancient societies"
    },
    "subfield:3303": {
      "kind": "subfield",
      "id": 3303,
      "parentKey": "field:33",
      "slug": "development",
      "name": "Development",
      "description": "International development and social change, including economic development, sustainable development, poverty reduction, development policy, and global inequality"
    },
    "subfield:3304": {
      "kind": "subfield",
      "id": 3304,
      "parentKey": "field:33",
      "slug": "education",
      "name": "Education",
      "description": "Educational theory and practice, including curriculum development, educational policy, teacher education, educational technology, assessment, and comparative education"
    },
    "subfield:3305": {
      "kind": "subfield",
      "id": 3305,
      "parentKey": "field:33",
      "slug": "geography-planning-and-development",
      "name": "Geography, Planning and Development",
      "description": "Spatial aspects of human society, including human geography, urban planning, regional development, GIS applications, environmental planning, and sustainable development"
    },
    "subfield:3306": {
      "kind": "subfield",
      "id": 3306,
      "parentKey": "field:33",
      "slug": "health",
      "name": "Health",
      "description": "Social dimensions of health and healthcare, including health sociology, medical anthropology, health policy, health disparities, and social determinants of health"
    },
    "subfield:3307": {
      "kind": "subfield",
      "id": 3307,
      "parentKey": "field:33",
      "slug": "human-factors-and-ergonomics",
      "name": "Human Factors and Ergonomics",
      "description": "The design of systems for human use, including workplace ergonomics, human-machine interaction, safety engineering, cognitive ergonomics, and user-centered design"
    },
    "subfield:3308": {
      "kind": "subfield",
      "id": 3308,
      "parentKey": "field:33",
      "slug": "law",
      "name": "Law",
      "description": "Legal systems and jurisprudence, including comparative law, international law, constitutional law, legal theory, law and society, and interdisciplinary legal studies"
    },
    "subfield:3309": {
      "kind": "subfield",
      "id": 3309,
      "parentKey": "field:33",
      "slug": "library-and-information-sciences",
      "name": "Library and Information Sciences",
      "description": "Information organization and access, including digital libraries, information retrieval, knowledge organization, information literacy, archives, and information policy"
    },
    "subfield:3310": {
      "kind": "subfield",
      "id": 3310,
      "parentKey": "field:33",
      "slug": "linguistics-and-language",
      "name": "Linguistics and Language",
      "description": "The scientific study of language, including theoretical linguistics, applied linguistics, psycholinguistics, computational linguistics, language documentation, and multilingualism"
    },
    "subfield:3311": {
      "kind": "subfield",
      "id": 3311,
      "parentKey": "field:33",
      "slug": "safety-research",
      "name": "Safety Research",
      "description": "Prevention of accidents and injuries, including occupational safety, transportation safety, product safety, risk perception, safety culture, and accident investigation"
    },
    "subfield:3312": {
      "kind": "subfield",
      "id": 3312,
      "parentKey": "field:33",
      "slug": "sociology-and-political-science",
      "name": "Sociology and Political Science",
      "description": "Social structures and political processes, including social movements, political sociology, social inequality, power relations, and the intersection of society and politics"
    },
    "subfield:3313": {
      "kind": "subfield",
      "id": 3313,
      "parentKey": "field:33",
      "slug": "transportation",
      "name": "Transportation",
      "description": "Movement of people and goods, including transportation planning, traffic engineering, logistics, sustainable transportation, transportation economics, and mobility studies"
    },
    "subfield:3314": {
      "kind": "subfield",
      "id": 3314,
      "parentKey": "field:33",
      "slug": "anthropology",
      "name": "Anthropology",
      "description": "The holistic study of humanity, including cultural anthropology, physical anthropology, linguistic anthropology, archaeological anthropology, and applied anthropology"
    },
    "subfield:3315": {
      "kind": "subfield",
      "id": 3315,
      "parentKey": "field:33",
      "slug": "communication",
      "name": "Communication",
      "description": "Human communication processes and media, including mass communication, interpersonal communication, digital media, journalism, public relations, and communication technology"
    },
    "subfield:3316": {
      "kind": "subfield",
      "id": 3316,
      "parentKey": "field:33",
      "slug": "cultural-studies",
      "name": "Cultural Studies",
      "description": "The analysis of contemporary culture and society, including popular culture, media studies, postcolonial studies, critical theory, and the politics of representation"
    },
    "subfield:3317": {
      "kind": "subfield",
      "id": 3317,
      "parentKey": "field:33",
      "slug": "demography",
      "name": "Demography",
      "description": "Population studies and dynamics, including fertility, mortality, migration, population aging, demographic methods, and the social and economic implications of population change"
    },
    "subfield:3318": {
      "kind": "subfield",
      "id": 3318,
      "parentKey": "field:33",
      "slug": "gender-studies",
      "name": "Gender Studies",
      "description": "The study of gender and sexuality, including feminist theory, masculinity studies, LGBTQ+ studies, gender inequality, and the intersection of gender with other social categories"
    },
    "subfield:3319": {
      "kind": "subfield",
      "id": 3319,
      "parentKey": "field:33",
      "slug": "life-span-and-life-course-studies",
      "name": "Life-span and Life-course Studies",
      "description": "Human development across the life course, including aging studies, life transitions, intergenerational relationships, life course epidemiology, and biographical research"
    },
    "subfield:3320": {
      "kind": "subfield",
      "id": 3320,
      "parentKey": "field:33",
      "slug": "political-science-and-international-relations",
      "name": "Political Science and International Relations",
      "description": "Politics and governance at all levels, including comparative politics, international relations, political theory, public policy, diplomacy, and global governance"
    },
    "subfield:3321": {
      "kind": "subfield",
      "id": 3321,
      "parentKey": "field:33",
      "slug": "public-administration",
      "name": "Public Administration",
      "description": "Government operations and public management, including public policy implementation, bureaucracy, public sector reform, e-government, and nonprofit management"
    },
    "subfield:3322": {
      "kind": "subfield",
      "id": 3322,
      "parentKey": "field:33",
      "slug": "urban-studies",
      "name": "Urban Studies",
      "description": "Cities and urbanization processes, including urban sociology, urban economics, housing studies, urban governance, smart cities, and urban sustainability"
    },
    "subfield:3400": {
      "kind": "subfield",
      "id": 3400,
      "parentKey": "field:34",
      "slug": "general-veterinary",
      "name": "General Veterinary",
      "description": "Interdisciplinary research spanning multiple areas of veterinary that bridges traditional boundaries within this field"
    },
    "subfield:3402": {
      "kind": "subfield",
      "id": 3402,
      "parentKey": "field:34",
      "slug": "equine",
      "name": "Equine",
      "description": "Horse health and medicine, including equine surgery, internal medicine, reproduction, sports medicine, nutrition, and the management of equine diseases and injuries"
    },
    "subfield:3404": {
      "kind": "subfield",
      "id": 3404,
      "parentKey": "field:34",
      "slug": "small-animals",
      "name": "Small Animals",
      "description": "Companion animal medicine, including dogs, cats, and exotic pets, covering internal medicine, surgery, behavior, nutrition, and preventive care for household pets"
    },
    "subfield:3500": {
      "kind": "subfield",
      "id": 3500,
      "parentKey": "field:35",
      "slug": "general-dentistry",
      "name": "General Dentistry",
      "description": "Comprehensive dental care, including preventive dentistry, restorative procedures, diagnosis of oral diseases, patient management, and primary dental healthcare delivery"
    },
    "subfield:3504": {
      "kind": "subfield",
      "id": 3504,
      "parentKey": "field:35",
      "slug": "oral-surgery",
      "name": "Oral Surgery",
      "description": "Surgical procedures of the mouth and jaw, including tooth extraction, dental implants, jaw surgery, oral pathology, trauma management, and maxillofacial reconstruction"
    },
    "subfield:3505": {
      "kind": "subfield",
      "id": 3505,
      "parentKey": "field:35",
      "slug": "orthodontics",
      "name": "Orthodontics",
      "description": "Correction of dental and facial irregularities, including braces, aligners, jaw growth modification, surgical orthodontics, and the biomechanics of tooth movement"
    },
    "subfield:3506": {
      "kind": "subfield",
      "id": 3506,
      "parentKey": "field:35",
      "slug": "periodontics",
      "name": "Periodontics",
      "description": "Gum disease and supporting structures of teeth, including gingivitis, periodontitis, gum surgery, dental implants, and regenerative periodontal procedures"
    },
    "subfield:3600": {
      "kind": "subfield",
      "id": 3600,
      "parentKey": "field:36",
      "slug": "general-health-professions",
      "name": "General Health Professions",
      "description": "Broad allied health topics, including interprofessional education, healthcare teams, professional development, health promotion, and integrated healthcare delivery"
    },
    "subfield:3603": {
      "kind": "subfield",
      "id": 3603,
      "parentKey": "field:36",
      "slug": "complementary-and-manual-therapy",
      "name": "Complementary and Manual Therapy",
      "description": "Alternative and hands-on therapeutic approaches, including chiropractic, massage therapy, osteopathy, acupuncture in allied health, and integrative manual therapies"
    },
    "subfield:3604": {
      "kind": "subfield",
      "id": 3604,
      "parentKey": "field:36",
      "slug": "emergency-medical-services",
      "name": "Emergency Medical Services",
      "description": "Pre-hospital emergency care, including paramedic practice, emergency medical technician training, disaster response, trauma care, and emergency medical system management"
    },
    "subfield:3605": {
      "kind": "subfield",
      "id": 3605,
      "parentKey": "field:36",
      "slug": "health-information-management",
      "name": "Health Information Management",
      "description": "Management of health data and information systems, including medical coding, health records administration, data privacy, healthcare analytics, and clinical documentation"
    },
    "subfield:3607": {
      "kind": "subfield",
      "id": 3607,
      "parentKey": "field:36",
      "slug": "medical-laboratory-technology",
      "name": "Medical Laboratory Technology",
      "description": "Clinical laboratory science and diagnostics, including clinical chemistry, hematology, microbiology, immunology, molecular diagnostics, and laboratory quality management"
    },
    "subfield:3608": {
      "kind": "subfield",
      "id": 3608,
      "parentKey": "field:36",
      "slug": "medical-terminology",
      "name": "Medical Terminology",
      "description": "Medical language and communication, including anatomical terminology, clinical vocabulary, medical documentation, terminology standards, and healthcare communication systems"
    },
    "subfield:3609": {
      "kind": "subfield",
      "id": 3609,
      "parentKey": "field:36",
      "slug": "occupational-therapy",
      "name": "Occupational Therapy",
      "description": "Helping people participate in daily activities, including functional assessment, adaptive equipment, sensory integration, work rehabilitation, and occupation-based interventions"
    },
    "subfield:3611": {
      "kind": "subfield",
      "id": 3611,
      "parentKey": "field:36",
      "slug": "pharmacy",
      "name": "Pharmacy",
      "description": "Medication therapy and pharmaceutical care, including clinical pharmacy, community pharmacy, hospital pharmacy, medication safety, and pharmaceutical patient care"
    },
    "subfield:3612": {
      "kind": "subfield",
      "id": 3612,
      "parentKey": "field:36",
      "slug": "physical-therapy-sports-therapy-and-rehabilitation",
      "name": "Physical Therapy, Sports Therapy and Rehabilitation",
      "description": "Movement science and rehabilitation, including musculoskeletal therapy, neurological rehabilitation, sports injury management, exercise prescription, and functional restoration"
    },
    "subfield:3614": {
      "kind": "subfield",
      "id": 3614,
      "parentKey": "field:36",
      "slug": "radiological-and-ultrasound-technology",
      "name": "Radiological and Ultrasound Technology",
      "description": "Medical imaging technology and practice, including radiography, sonography, CT, MRI, radiation safety, image quality, and diagnostic imaging procedures"
    },
    "subfield:3616": {
      "kind": "subfield",
      "id": 3616,
      "parentKey": "field:36",
      "slug": "speech-and-hearing",
      "name": "Speech and Hearing",
      "description": "Communication disorders and audiology, including speech-language pathology, hearing assessment, cochlear implants, swallowing disorders, and communication rehabilitation"
    }
  }
}
